import React from "react";

const Mentions = () => (
  <div className="legal-page">
    <h2>Mentions légales</h2>
    <p>Voici les mentions légales de notre site...</p>
  </div>
);

export default Mentions;
